export default __webpack_public_path__ + "static/SectionTwo_02_03@2x-7645046bfe8599de5a1ed68512c5d97c.webp";